import React, {useState, useEffect} from 'react';
import axios from 'axios';

const AboutTheFounder = () =>{

    const[founder,setFounder]= useState([]);

    useEffect(()=>{
      axios.get("https://www.cadandrender.com/adminPanel/API/founder-details.php").then((response)=>{
        setFounder(response.data.Founder);
    })
    },[]);
    
    return (
        <>
            <div className='cadAboutContent'>
                <div className='container'>
                    <p>At CAD and RENDER, we specialize in providing high-quality jewelry 3D CAD Designing and Realistic Rendering services to jewelry manufacturers, wholesalers and retailers. With years of experience in the industry, we have become experts in our craft and are dedicated to providing exceptional service to our clients.</p>
                </div>
            </div>

            <div className='cadAboutOwner'>
                <div className='container'>
                    <div className='cadServicesInner row'>
                        <div className='cadServicesInnerCol col-12'>
                        {founder.map((res) => (
                            <div className='cadServicesInnerAlign row'>
                                <div className='cadServicesImgsec col-6'>
                                    <div className='cadServicesImgSecInner'>
                                        <img 
                                        src={res.Founder_MediaUrl}
                                        alt="cad-owner" />
                                    </div>
                                </div>
                                <div className='cadServicesContent col-6'>
                                    <h2>{res.Founder_Title}</h2>
                                    <h5>{res.Founder_SubTitle}</h5>
                                    <div className='cad-about-founder-description' dangerouslySetInnerHTML={{ __html: res.Founder_Description }} />
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutTheFounder;